
export const BACKEND_SVR_URL = 'https://dwindle-backend-server.herokuapp.com'; 
// 'http://localhost:5000'

